import { render, staticRenderFns } from "./ModalEditarGeo.vue?vue&type=template&id=0bf75154&scoped=true&"
import script from "./ModalEditarGeo.vue?vue&type=script&lang=js&"
export * from "./ModalEditarGeo.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditarGeo.vue?vue&type=style&index=0&id=0bf75154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf75154",
  null
  
)

export default component.exports